import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 850px;
  height: 650px;
  padding: 10px 20px;
  margin-left: 60px;
  position: relative;
  overflow: hidden;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.delay {
    animation-delay: 0.15s;
  }

  &.animated {
    animation-duration: 0.3s !important;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 80px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin-left: 0;
    position: absolute;
    top: 10px;
    height: calc(100vh - 100px);
  }

  ${mediaMaxWidth.phone} {
    position: absolute;
    top: 10px;
    height: calc(100vh - 150px);
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone} {
    margin: 2px 0 7px 0;
  }
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 12px;
  right: 30px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 100px);
  overflow: scroll;

  a {
    text-align: center;
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 0;
  }
`;

export const Options = styled.div`
  margin: 20px 10px;

  ${mediaMaxWidth.phone} {
    margin: 0 10px;
  }
`;

export const CheckBoxesGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 5px 32px;
  flex-flow: row wrap;

  ${mediaMaxWidth.phone} {
    flex-flow: unset;
    flex-direction: column;
    margin: 3px 32px 10px 32px;
  }
`;

export const CheckBoxesGroupItem = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px 0;
  width: 50%;

  ${mediaMaxWidth.phone} {
    width: 100%;
    margin: 3px 0;
  }
`;

export const Indicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #79D9D9;
  }
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${Indicator} {
    background: #79D9D9;
    border: 2px solid #79D9D9;

    &:after {
      display: block;
    }
  }
`;

export const CheckBoxLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 400;
  color: #333;
`;

export const Preview = styled.div`
  position: relative;
  margin: 10px;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-weight: 100;
  color: #333;
  font-size: 0.95em;
  font-style: italic;

  ${mediaMaxWidth.phone} {
    text-align: left;
    text-decoration: underline;
    margin-bottom: 10px;

    &:after {
      content: ":";
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;

    ${mediaMaxWidth.smallPhone} {
      font-size: 0.9em;
      margin: 5px;
    }
  }
`;
